import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import DocumentHitsFormat from '@Components/Results/services/document-hits-format.service';

function DocumentAbstractHit({ abstractText, closeClick, trackingAttrs }) {
  const abstractHit = DocumentHitsFormat.checkAndFormatHit(abstractText, 'abstract');

  return abstractHit ? (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className="result-detail-panel u-els-margin-top-1o2 e2e-document-action-abstract-hit"
      onClick={closeClick}
      role="button"
      tabIndex="0"
      {...trackingAttrs}>
      <div className="result-detail-panel-wrapper">
        <h4 className="u-els-margin-bottom-1o2">Abstract hit:</h4>
        <InnerHTML tag="div" className="result-detail-block u-els-font-size-base u-els-line-height-default" html={abstractHit} />
        <svg className="els-btn-icon svg-icon els-btn-icon-sm collapsable-section-chevron">
          <use xlinkHref="#icon-chevron-down" />
        </svg>
      </div>
    </div>
  ) : null;
}

DocumentAbstractHit.propTypes = {
  abstractText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
  trackingAttrs: PropTypes.object.isRequired,
};

export default DocumentAbstractHit;
